/**
 * Created by intellicar-rinas on 4/10/17.
 */
import {
  schemaTypes,
  dateFormat,
  fuelTypeMap,
  simpleTimeFormat,
} from "../../../constants/constants";
import ReportAPIs from "../../../APIs/ReportAPIs";
import GeoCodeAPIs from "../../../APIs/GeoCodeAPIs";
import { JSONToCSVConvertor, stripLoc } from "../../../helpers/helperFunctions";
import momentTZ from "moment-timezone";
import {
  flipRange,
  canShowRangeSwitch,
  onFetchOdo,
  changeVehicle,
} from "./historyReport/historyReport";
import moment from "moment";
import _ from "lodash";
import { getFuelPrices } from "./tripReport";
import { duration as formatChange } from "../reports/railwaysReport/railwaysReport";
// import mixpanel from "mixpanel-browser";
import { isEvGroup } from "../reports/summaryReport";
import actions from "../../../store/actions";

export const changeToHours = (dur) => {
  if (!dur) return "--";
  // get hours & multiply fractional part by 60 to get minutes
  let hrs = dur / 60;
  let min = parseInt((hrs % 1) * 60, 10);
  hrs = parseInt(hrs, 10);
  let els = min + " min";
  if (hrs > 0) els = hrs + " hrs " + els;
  return els;
};
const isIdlingShowable = (item, props) => {
  let groups = props.groupTree.children.map((g) => g.name);
  let disable =
    ((window.userInfo || {}).SELF || {}).disableIdlingFromReports !== "DISABLE";
  if (groups.includes("KushalSSLLP")) return false;
  return disable;
};

const filterHeading = [
  {
    users: ["unilet.blr"],
    // blacklist: [],
    whitelist: [
      "vehicleno",
      "starttime",
      "endtime",
      "distance",
      "startloc",
      "endloc",
    ],
  },
];

const isRangeShow = (item) => {
  if (
    window.userInfo &&
    window.userInfo.SELF &&
    window.userInfo.SELF.enable_range
  ) {
    return true;
  } else {
    return false;
  }
};
const isHeadShowable = (item, props, head) => {
  //if(isEvGroup(item)) return false
  let username = (((props || {}).auth || {}).userinfo || {}).username;
  if (!username || !head) return true;
  let blacklist = null;
  let whitelist = null;
  let colName = head.key;
  for (let idx in filterHeading) {
    if (
      filterHeading[idx].users &&
      filterHeading[idx].users.indexOf(username) !== -1
    ) {
      whitelist = filterHeading[idx].whitelist || [];
      blacklist = filterHeading[idx].blacklist || [];
    }
  }

  if (whitelist !== null) return whitelist.indexOf(colName) !== -1;

  if (blacklist !== null) return whitelist.indexOf(colName) === -1;

  return true;
};

export const processData = (respObj, vehicleMap, callback) => {
  let historyData = [];

  for (let vehiclepath in respObj) {
    let vehicleno = vehicleMap[vehiclepath].vehicleno;
    for (let ridx in respObj[vehiclepath]) {
      let eachitem = respObj[vehiclepath][ridx];
      let starttime =
        eachitem.starttime != null ? new Date(eachitem.starttime) : null;
      let endtime =
        eachitem.endtime != null ? new Date(eachitem.endtime) : null;
      let total_distance_km = eachitem.total_distance_km? parseFloat(eachitem.total_distance_km.toFixed(2)) : null
      let soc_consumed = eachitem.soc_consumed ? parseFloat(eachitem.soc_consumed.toFixed(2)) : null
      let range_km_per_pct = eachitem.range_km_per_pct ? parseFloat(eachitem.range_km_per_pct.toFixed(2)) : null
      let start_soc = eachitem.start_soc ? parseFloat(eachitem.start_soc.toFixed(2)) : null
      let end_soc = eachitem.end_soc ? parseFloat(eachitem.end_soc.toFixed(2)) : null
      let start_odo = eachitem.start_odo ? parseFloat(eachitem.start_odo.toFixed(2)) : null
      let end_odo = eachitem.end_odo ? parseFloat(eachitem.end_odo.toFixed(2)) : null
      let odo_from = eachitem.odo_from ? eachitem.odo_from : null

      historyData.push({
        soc_consumed,
        total_distance_km,
        range_km_per_pct,
        start_soc,
        end_soc,
        start_odo,
        end_odo,
        odo_from,
        vehicleno,
        starttime,
        endtime,
        total_distance_km
    });
    }
  }

  callback(historyData);
  
};

const getHistory = (schema, data, store) => {
  window.resetIndex();
  window.getButtonClicked = true;
  schema.showPage = true;
  schema.finalData = null;
  let saveState = null;
  let tableStateData = null;
  window.graphDataErr = "";
  let starttime = data.starttime.unix() * 1000;
  let endtime = data.endtime.unix() * 1000;
  let vehicleDataForReport = {};
  let fixedQueryLimit = 700;
  let splitedVehicles = [];
  data.vehicle =
    window.selectedItems && window.selectedItems.length
      ? window.selectedItems
      : window.itemClicked
      ? window.selectedVehicles
      : [];
  if (!data.vehicle.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Please select a vehicle",
        content: "Please select a vehicle",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (endtime - starttime > 1000 * 60 * 60 * 24 * 35) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "You can't select a date range of more than 35 days",
        content: "You can't select date range of more than 35 days",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  if (starttime >= endtime) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "Start time should be less than the end time",
        content: "Start time should be less than the end time",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  
  let days = endtime - starttime;
  schema.count = 0;
  days = Math.ceil(days / 86400000); //total days
  let queryLimit = data.vehicle.length * days; // total query limit
  schema.count = Math.ceil(queryLimit / fixedQueryLimit); // page number
  schema.splitCount = parseInt(data.vehicle.length / schema.count); // total vehicle / total pages
  if (schema.splitCount > 50) schema.splitCount = 50;

  let startIndex = 0;
  let endIndex = schema.splitCount;
  for (let pages = 0; pages < schema.count; pages++) {
    let page = [];
    for (let idx in data.vehicle) {
      if (idx >= startIndex && idx <= data.vehicle.length) {
        if (idx <= endIndex - 1) page.push(data.vehicle[idx].id);
      }
    }
    splitedVehicles.push(page);
    startIndex = endIndex;
    endIndex = startIndex + schema.splitCount;
    if (pages === schema.count - 1 && startIndex <= data.vehicle.length) {
      if (data.vehicle.length - startIndex > 0) {
        schema.count++;
      }
    }
  }
  if (data.vehicle && data.vehicle.length) {
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, true);
    const handleSuccess = (resp) => {
      window.dataForAll = resp;
      if (window.setReportWindowTabBusy)
        window.setReportWindowTabBusy(schema, false);
      processData(resp, store.vehicleMap, (data) => {
        schema.finalData = data;
        vehicleDataForReport = {
          endtime: endtime,
          starttime: starttime,
          batteryVehicles: splitedVehicles,
          reportName: schema.key,
          BatteryFirstData: data,
          selectedVehicles: data.vehicle,
          batteryPageno: schema.count,
          showPage: schema.showPage,
          selectedDailyVehicles: data.vehicle,
        };
        store.dispatch({
          type: actions.SELECTED_VEHICLE_ID,
          data: vehicleDataForReport,
        });
        if (tableStateData && tableStateData[0]) {
          tableStateData[0].body = data;
          tableStateData[0].busy = false;
          saveState(tableStateData[0], tableStateData[1], tableStateData[2]);
        }
        if (schema.content[0].ref) {
          schema.content[0].ref.setData(data);
        }
      });
    };
    if (schema.content[0].ref) {
      schema.content[0].ref.setBusy(true);
      saveState = schema.content[0].ref.props.saveState;
      tableStateData = [
        schema.content[0].ref.state,
        schema.content[0].ref.props.schemaKey,
        schema.content[0].ref.props.data,
      ];
    }
    let body = {
      vehicleid: splitedVehicles[0],
      starttime: starttime,
      endtime: endtime,
    };
    ReportAPIs.getClnBatteryTripReport(body).then(handleSuccess, (r) => {
      handleSuccess({});
    });
  } else {
    window.dataForAll = null;
    window.graphDataErr = "Please Select Vehicle";

    if (window.InMapForceUpdate) {
      window.InMapForceUpdate();
    }
    if (window.InGraphControlForceUpdate) {
      window.InGraphControlForceUpdate();
    }
   
    if (window.setReportWindowTabBusy)
      window.setReportWindowTabBusy(schema, false);
    return;
  }
};

const flipRangeWrap = flipRange.call(this, (report) => {
  report.schema.toolbar[4].onClick = report.odometerRange
    ? onFetchOdo(getHistory)
    : getHistory;
});

const download = (schema, data, store) => {
  let filterdData = schema.content[0].ref.state.body;
  if (!filterdData.length) {
    store.dispatch({
      type: "ADD_INTOAST",
      data: {
        name: "No data Available",
        content: "No data Available",
        createAt: Date.now(),
        autoClose: 8000,
        showError:true
      },
    });
    return;
  }
  schema.finalData = filterdData;
  if (schema.finalData) {
    let finalData = _.map(schema.finalData, (r) => {
      r = Object.assign({}, r);
      r.starttime = moment(r.starttime).format(dateFormat);
      r.endtime = moment(r.endtime).format(dateFormat);
      
      return r;
    });
    
   
    let heads = schema.content[0].head;
    // let removeHeads = [
    //   "mileage",
    //   "acidlingtime",
    //   "tripscore",
    //   "startdte",
    //   "enddte",
    //   "cpk",
    //   "fuelprice",
    //   "uid",
    //   "starttime__processed__",
    //   "endtime__processed__",
    //   // "fuelused",
    //   "ophours",
    //   "consumption",
    //   "cph",
    // ];
    // if (isEvGroup(data.vehicle)) {
    //   removeHeads.push("idlingtime");
    // }
    // heads = heads.filter((head) => {
    //   if (!removeHeads.includes(head.key)) {
    //     return head;
    //   }
    // });
    let newData = [];
    for (let idx in finalData) {
      let tempdata = {};
      for (let rdx in heads) {
        if (heads[rdx].key in finalData[idx]) {
          let key = heads[rdx].key;
          let name = heads[rdx].name;
          tempdata[name] = finalData[idx][key];
        }
      }
      newData.push(tempdata);
    }
    setTimeout(() => { 
      JSONToCSVConvertor(newData, "batteryTripReport", false);
    }, 500);
  }
};

const schema = {
  key: "battery_trip_report",
  name: "Battery Trip Report",
  showPage: false,
  count: null,
  splitCount:null,
  finalData:null,
  toolbar: [
    {
      key: "vehicle",
      type: schemaTypes.MULTI_SELECT,
      storeData: (state) => {
        return {
          data: (() => {
            let newMap = {};
            for (let idx in state.vehicleMap) {
              if (idx.indexOf("user") === -1) {
                newMap[idx] = state.vehicleMap[idx];
              }
            }
            return newMap;
          })(),
          name: "vehicleno",
          id: "vehicleid",
        };
      },
      maxCount: 6000,
      onItemChange: changeVehicle.bind(this),
      defaultValue: () => {
        return {
          data: window.selectedVehicles.map((i) => {
            return i.id;
          }),
          updatedAt: window.selectedVehiclesUpdatedAt,
        };
      },
    },
    {
      key: "switch",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-exchange",
      onClick: flipRangeWrap,
      tooltip: "Switch between date range and odometer",
      isShowable: canShowRangeSwitch,
    },
    {
      key: "starttime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "Start Date",
      model: Date.now() - 1000 * 60 * 60 * 24,
      hideTime: true,
      schemaKey: "range_report",
    },
    {
      key: "endtime",
      type: schemaTypes.DATE_PICKER,
      setIfNull: true,
      placeholder: "End Date",
      model: Date.now() - 1000 * 60,
      hideTime: true,
      schemaKey: "range_report",
    },
    {
      key: "get_history",
      type: schemaTypes.BUTTON,
      name: "Get Battery Report",
      onClick: getHistory,
    },
    {
      key: "download",
      type: schemaTypes.BUTTON,
      iconType: "class",
      icon: "fa fa-download",
      onClick: download,
      tooltip: "Download Page",
    },
  ],
  content: [
    {
      key: "dataTable",
      type: schemaTypes.IN_TABLE,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
      head: [
        {
          key: "vehicleno",
          name: "Vehicle No",
          isShowable: isHeadShowable,
        },
        {
          key: "start_epoch_ms",
          name: "Start Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
          isShowable: isHeadShowable,
        },
        {
          key: "end_epoch_ms",
          name: "End Time",
          type: "DATE",
          format: dateFormat,
          width: 1.5,
          isShowable: isHeadShowable,
        },
        { key: "total_distance_km", name: "Distance (km)", isShowable: isHeadShowable },
        { key: "soc_consumed", name: "SOC Consumed (%)", isShowable: isHeadShowable },
        { key: "range_km_per_pct", name: "Range KM Per Pct", isShowable: isHeadShowable },
        { key: "start_soc", name: "Start SOC", isShowable: isHeadShowable },
        { key: "end_soc", name: "End SOC", isShowable: isHeadShowable },
        { key: "start_odo", name: "Start Odo (km)", isShowable: isHeadShowable },
        { key: "end_odo", name: "End Odo (km)", isShowable: isHeadShowable },
        { key: "odo_from", name: "Odo From", isShowable: isHeadShowable },

      ],
    },
  ],
};
export default schema;
